import { PlanType } from "../../models/types";

export default function PlanBadge({ plan }: { plan: PlanType }) {
    return <span className={`inline-flex items-center rounded-md px-1.5 py-0.5 text-xs font-medium ${plan === "SUBSCRIBER" ? "bg-green-100 text-green-700" : plan === "OSD" ? "bg-blue-100 text-blue-700" : "bg-gray-100 text-gray-600"}`}>
        {plan}
    </span>

}